/**
 * This file is a copy of autogenerated tokens. It is included only as a temporal fallback.
 */
export const LEGACY_TOKENS = {
    baseLayout: {
        gutter: {
            value: '16px',
            variant: {
                breakpointLargeUp: {
                    value: '24px',
                },
            },
        },
        horizontalMargin: {
            value: '16px',
            variant: {
                breakpointLargeUp: {
                    value: '24px',
                },
            },
        },
        maxWidth: {
            value: 'none',
            variant: {
                small: {
                    value: '640px',
                },
                large: {
                    value: '960px',
                },
            },
        },
    },
    twoColumnLayoutCell: {
        width: {
            value: '100%',
            variant: {
                breakpointMediumUp: {
                    value: '50%',
                },
            },
        },
    },
    threeColumnLayoutCell: {
        width: {
            value: '100%',
            variant: {
                breakpointMediumUp: {
                    value: '50%',
                },
                breakpointLargeUp: {
                    value: '33.33%',
                },
            },
        },
    },
    fourColumnLayoutCell: {
        width: {
            value: '50%',
            variant: {
                breakpointMediumUp: {
                    value: '33.33%',
                },
                breakpointLargeUp: {
                    value: '25%',
                },
            },
        },
    },
    fiveColumnLayoutCell: {
        width: {
            value: '50%',
            variant: {
                breakpointMediumUp: {
                    value: '33.33%',
                },
                breakpointLargeUp: {
                    value: '25%',
                },
                breakpointExtraLargeUp: {
                    value: '20%',
                },
            },
        },
    },
    contentWithSidebarLayoutSidebarCell: {
        width: {
            value: '100%',
            variant: {
                breakpointLargeUp: {
                    value: '33.33%',
                },
            },
        },
    },
    contentWithSidebarLayoutContentCell: {
        width: {
            value: '100%',
            variant: {
                breakpointLargeUp: {
                    value: '66.66%',
                },
            },
        },
    },
    contentWithTwoSidebarsLayoutSidebarCell: {
        width: {
            value: '50%',
            variant: {
                breakpointLargeUp: {
                    value: '25%',
                },
            },
        },
    },
    contentWithTwoSidebarsLayoutContentCell: {
        width: {
            value: '100%',
            variant: {
                breakpointLargeUp: {
                    value: '50%',
                },
            },
        },
    },
};
